import { Layout } from 'antd';
import styles from './OffCycle.module.css';
import SideNavBar from '../../Components/SideBar/Sidebar';
import Navbar from '../../Components/Support/Header';
import OffCycleGrid from '../../Components/OffCycle/OffCycleGrid';

const { Content, Header } = Layout;

const OffCyclePage = () => {

    return (
        <Layout className={styles['offcycle-pager-container']}>
            <SideNavBar />
            <Layout>
                <Header className={`${styles['flex-items-end']} ${styles['header-container']}`}>
                    <Navbar />
                </Header>
                <Content className={styles['content-container']}>
                    <OffCycleGrid/>
                </Content>
            </Layout>
        </Layout>
    )
}

export default OffCyclePage;
